export const getAssessmentLink = function (params = {}) {
  let body = ''
  if (params.hutk) {
    body = `utk=${params.hutk}`
  } else if (params.email) {
    body = `email=${params.email}`
  } else {
    return false
  }

  return fetch(sharedApiUrl + '/assessments/v4/get-assessment-url.php', {
    method: 'POST',
    body: body,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  })
    .then(response => response.json())
    .then(result => {
      return result
    })
}